module.exports = __webpack_public_path__ + "27dfab2550af1c47fab0b7890ad20c10.svg";